import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Linkedin, Twitter, Facebook, Youtube, Globe } from "lucide-react";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import googlePlayImage from "../../assets/assets/gpfooter.png"; 
import appstoreImage from "../../assets/assets/appstore.png"; 
import { NavLink } from "react-router-dom";

const Footer = ({ navLinks, contactInfo  }) => {
  const socialLinks = [
    { icon: Linkedin, url: "https://in.linkedin.com/in/ventureintelligence", name: "LinkedIn" },
    { icon: Twitter, url: "https://twitter.com/ventureindia", name: "Twitter" },
    { icon: Facebook, url: "https://www.facebook.com/ventureintelligence", name: "Facebook" },
    { icon: Globe, url: " https://blog.ventureintelligence.com/", name: "Blogspot" },
    { icon: Youtube, url: "https://www.youtube.com/VentureIntelligence", name: "YouTube" },
  ];

  return (
    <footer className="bg-slate-700 py-7 px-4 md:px-6" id="Contact">
      <div className="">
        
        {/* Navigation and Links - if still needed */}
        {navLinks && (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-10">
            {navLinks?.map((link) => (
              <div key={link.name} className="space-y-3">
                <h3 className="text-base font-bold text-[#bb8b1f] border-b border-[#bb8b1f] pb-2">
                  {link.name}
                </h3>
                <ul className="space-y-2 text-sm">
                  {link?.options?.map((option) => (
                    <li key={option.name}>
                      <a href={option.to} className="text-[#5c4610] hover:text-[#bb8b1f] transition-colors">
                        {option.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* Updated Sitemap Section with Contact Info */}
        <div className="mb-8 bg-slate-700 rounded-lg p-8 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            
            {/* First Column - Databases + Directory */}
            <div className="space-y-6">
              <div className="space-y-4">
                <h4 className="font-bold text-lg text-white mb-3">Databases</h4>
                <ul className="space-y-2">
                  <li><a href="/products/pe" className="text-gray-300  transition-colors text-sm leading-relaxed block">Private Equity - Venture Capital Database</a></li>
                  <li><a href="/products/cfs" className="text-gray-300  transition-colors text-sm leading-relaxed block">Company Financials Search (CFS) Database</a></li>
                  <li><p className="text-gray-300  transition-colors text-sm leading-relaxed block">Merger and Acquisitions Database</p></li>
                  <li><p className="text-gray-300  transition-colors text-sm leading-relaxed block">Private Equity-Real Estate Database</p></li>
                </ul>
              </div>
              
              <div className="space-y-4">
                <h4 className="font-bold text-lg text-white mb-3">Directory</h4>
                <ul className="space-y-2">
                  <li><a href="/pedirectory" className="text-gray-300  transition-colors text-sm leading-relaxed block">The India Private Equity / Venture Capital Directory</a></li>
                  <li><a href="/peredirectory" className="text-gray-300  transition-colors text-sm leading-relaxed block">The India Private Equity-Real Estate Directory</a></li>
                  <li><a href="/pedirectory" className="text-gray-300  transition-colors text-sm leading-relaxed block">Directory of Early Stage Investors in India</a></li>
                  <li><a href="/lpdirectory" className="text-gray-300  transition-colors text-sm leading-relaxed block">Limited Partners Directory</a></li>
                </ul>
              </div>
            </div>

            {/* Second Column - Deal Digest + Other Products */}
            <div className="space-y-6">
              <div className="space-y-4">
                <h4 className="font-bold text-lg text-white mb-3">Deal Digest Newsletter</h4>
                <ul className="space-y-2">
                  <li><a href="/newsletters" className="text-gray-300  transition-colors text-sm leading-relaxed block">Premium Daily Edition</a></li>
                  {/* <li><a href="/weekly-newsletter" className="text-gray-300  transition-colors text-sm leading-relaxed block">Free Weekly Edition</a></li> */}
                </ul>
              </div>
              
              <div className="space-y-4">
                <h4 className="font-bold text-lg text-white mb-3">Other Products & Services</h4>
                <ul className="space-y-2">
                  <li><a href="/products/justaskvi" className="text-gray-300  transition-colors text-sm leading-relaxed block">Just Ask VI</a></li>
                  <li><a href="/leagues" className="text-gray-300  transition-colors text-sm leading-relaxed block">League Tables</a></li>
                  <li><a href="/india-venture-capital-landscape-report-2025" className="text-gray-300  transition-colors text-sm leading-relaxed block">VC Landscape Report</a></li>
                  <li><a href="/seriesareport" className="text-gray-300  transition-colors text-sm leading-relaxed block">Series A Landscape Report</a></li>
                  <li><a href="/peimpact" className="text-gray-300  transition-colors text-sm leading-relaxed block">Private Equity Impact Report</a></li>
                  <li><a href="/entrepreneurs" className="text-gray-300  transition-colors text-sm leading-relaxed block">Products for Entrepreneurs</a></li>
                  <li><a href="https://news.ventureintelligence.com/" className="text-gray-300  transition-colors text-sm leading-relaxed block">VI News Digest</a></li>
                </ul>
              </div>
            </div>

            {/* Third Column - Additional Services with H2 tags */}
            <div className="space-y-4">
              <h2 className="text-xl font-bold text-white mb-4">Quick Links</h2>
              <ul className="space-y-2">
                <li><a href="/Indian-Unicorn-Tracker" className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block">Indian Unicorn Tracker</a></li>
                <li><a href="/ipo-tracker" className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block">Startup IPO Tracker</a></li>
                <li><a href="/Press-Release" className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block">Press Releases</a></li>
                <li><a href="/Events" className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block">Events</a></li>
                <li><a href="https://blog.ventureintelligence.com/" className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block">VI Blog</a></li>
                <li>
                  <a
                    href={window.location.pathname.includes("landing2") ? "/trial2.htm" : "/trial.html"}
                    className="text-gray-300  transition-colors text-base font-semibold leading-relaxed block"
                  >
                    Request Demo
                  </a>
                </li>              
              </ul>
            </div>

            {/* Fourth Column - Contact Information */}
            <div className="space-y-6">
              <h2 className="text-xl font-bold text-white mb-4">Contact Us</h2>
              
              {/* Office Locations */}
              <div className="space-y-4">
                <div className="space-y-2">
                  <h4 className="font-semibold text-base text-gray-300">Registered Office</h4>
                  <div className="flex items-start space-x-2 text-sm hover:text-gray-400">
                    <FontAwesomeIcon icon={faLocationDot} className="text-white mt-1 flex-shrink-0 hover:text-gray-400" />
                    <a href="https://goo.gl/maps/MrVkwNd3qL4zNSLv8" target="_blank" className="text-white hover:text-gray-400 transition-colors">
                      1, Maharani Chinnamba Road, Alwarpet,<br/> Chennai-600 018, INDIA
                    </a>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <h4 className="font-semibold text-base text-gray-300">Chennai OMR Office</h4>
                  <div className="flex items-start space-x-2 text-sm hover:text-gray-400">
                    <FontAwesomeIcon icon={faLocationDot} className="text-white hover:text-gray-400 mt-1 flex-shrink-0" />
                    <a href="https://goo.gl/maps/1ehpk9JaReGKUxt66" target="_blank" className="text-white hover:text-gray-400 transition-colors">
                      30, 1st Street, Srinivasa Nagar, Kottivakkam,<br/> Chennai-600 096, INDIA
                    </a>
                  </div>
                </div>
              </div>

              {/* Phone & Email */}
              <div className="text-sm space-y-3">
                <div className="flex items-center space-x-2  text-white">
                  <FontAwesomeIcon icon={faPhone} className="text-white flex-shrink-0" />
                  <p>+91- 9176000521 / 9176033455</p>
                </div>
                <div className="flex items-start space-x-2">
                  <FontAwesomeIcon icon={faEnvelope} className="text-white mt-1 flex-shrink-0" />
                  {contactInfo !== undefined ? <a
                    href={`mailto:${contactInfo.mail}?subject=Website%20based%20enquiry`}
                    className="hover:text-gray-400 text-white transition-colors text-sm"
                  >
                    {contactInfo.mail}
                  </a> : <a
                    href="bizdev@ventureintelligence.com"
                    className="hover:text-gray-400 text-white transition-colors text-sm"
                  >
                    bizdev@ventureintelligence.com
                  </a>}
                </div>
              </div>
              
              {/* Social Links */}
              <div className="text-left">
                <h4 className="font-semibold text-base text-gray-300 mb-3">Follow us on</h4>
                <div className="flex justify-start space-x-4">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-gray-400 text-white transition-colors"
                      title={social.name}
                    >
                      <social.icon size={20} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm text-white border-t border-white pt-4">
          <span>© TSJ Media Pvt Ltd. All rights reserved</span>
          <NavLink to={"/privacypolicy"} className="hover:text-gray-400 transition-colors">
            Privacy Policy
          </NavLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;